import { useMutation, useQuery } from '@apollo/client/react';
import { chakra, Box, Center, Heading, HStack, Spinner, Text, Button, Link } from '@chakra-ui/react';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { gql } from '@src/lib/gql';
import React, { useCallback } from 'react';
import { LuSquareArrowUpRight } from 'react-icons/lu';
export const FundableAccountsBlock = (props: {}) => {
  const query = useQuery(gql`
    query {
      viewer {
        id
        currentUser {
          id
          provisionedAccounts {
            id
            application
            couponCode
            reference
          }
        }
      }
    }
  `);
  const [provisionAccount, provisionAccountMutation] = useMutation(gql`
    mutation ($input: CreateProvisionedAccountInput!) {
      createProvisionedAccount(input: $input) {
        provisionedAccount {
          id
        }
      }
    }
  `);
  const handleCouponGeneration = useCallback(async () => {
    try {
      await provisionAccount({
        variables: {
          input: {
            application: 'fundable'
          }
        }
      });
      await query.refetch();
    } catch (err) {
      alert('An error occurred. Please contact support@startups.com.');
    }
  }, []);
  const accounts = query.data?.viewer?.currentUser?.provisionedAccounts || [];
  const fundableAccounts = accounts.filter(a => a.application == 'fundable') || [];
  return <Box bgColor={'colorPalette.container'} border={'1px solid {colors.colorPalette.border/50}'} borderRadius={'md'} padding={6} width={'full'}>
      <HStack align={'center'} justify={'space-between'}>
        <Box>
          <Heading>Fundable.com</Heading>
          <Text>Raise Startup Capital</Text>
        </Box>
        <Box>
          <PaywalledAction contentPermission={'canActivateFundable'}>
            <>
              {fundableAccounts.length == 0 && <Button disabled={provisionAccountMutation.loading || query.loading} loading={provisionAccountMutation.loading || query.loading} onClick={handleCouponGeneration}>
                  {provisionAccountMutation.loading ? 'Loading...' : 'Redeem Your Free Account'}
                </Button>}
            </>
          </PaywalledAction>
        </Box>
      </HStack>
      <PaywalledAction contentPermission={'canActivateFundable'} variant={'blank'}>
        {query.loading && <Center padding={'1em'}>
            <Spinner />
          </Center>}
        {fundableAccounts.length > 0 && <Box paddingTop={'1em'}>
            {fundableAccounts.map(account => <Box key={account.id} bgColor={'colorPalette.bg'} padding={'3em'} textAlign={'center'}>
                <Text>
                  {'You can use the coupon code'}{' '}
                  <chakra.code bgColor={'BurntOrange'} fontWeight={'bold'} padding={'0.125em 0.5em'}>
                    {account.couponCode}
                  </chakra.code>{' '}
                  to unlock 1 Free Fundable Fundraise.
                </Text>
                <Button asChild marginTop={'1em'} size={'sm'} variant={'outline'}>
                  <Link href={'https://www.fundable.com/company/signup'} target={'_blank'}>
                    Redeem on Fundable.com
                    <LuSquareArrowUpRight />
                  </Link>
                </Button>
              </Box>)}
          </Box>}
      </PaywalledAction>
    </Box>;
};